<template>
  <div class="requisition-report-comments d-flex flex-column justify-center">
    <div
      v-if="isCordLoading"
      class="d-flex justify-center"
    >
      <v-progress-circular
        indeterminate
        color="brandPrimary"
        size="40"
      />
    </div>

    <div v-else>
      <cord-threaded-comments
        :location="JSON.stringify(threadLocation)"
        :thread-metadata="JSON.stringify(threadMetaData)"
        :thread-name="threadName"
        composer-position="top"
        display-resolved="sequentially"
        top-level-composer-expanded="false"
        scroll-direction="down"
      />
    </div>
  </div>
</template>

<script>
import { useCommenting } from '@/stores/commenting/commenting';

export default {
  name: 'RequisitionReportComments',

  props: {
    reqId: { type: String, default: '' },
    reqUuid: { type: String, default: '' },
    reqTitle: { type: String, default: '' },
  },

  computed: {
    isCordLoading() {
      return useCommenting().isCordLoading;
    },
    threadLocation() {
      return { page: 'requisition-report', id: this.reqUuid };
    },
    threadMetaData() {
      return { reqUuid: this.reqUuid, reqId: this.reqId };
    },
    threadName() {
      return this.reqTitle;
    },
  },
};
</script>

<style scoped lang="less">
@import '@/less/cord';

.requisition-report-comments {
  text-align: initial;
  background: @white;
  min-width: 400px;
  min-height: 200px;

  .cord-common-styles();
  .cord-message-styles();
  .cord-threaded-comments-styles();

  &:deep(.cord-threaded-comments) {
    width: 400px;
    max-height: calc(100vh - 168px);
  }

  &:deep(.cord-overlay) {
    // this improves detailed cord image view for widget screenshots.
    // the styles help compensate positioning of v-menu that holds cord elements
    // and it doesn't work great.
    // TODO: get rid of v-menu in RequisitionReportCommentsToggle.vue
    width: 90vw;
    left: calc(400px - 90vw);
    height: 60vh;
    top: -126px;
  }
}
</style>
